import React from 'react';

const MediaAuthoritySection = () => {
  return (
    <section className="section-padding-sm bg-[var(--bg-secondary)]">
      <div className="container">
        <div className="max-w-5xl mx-auto text-center">
          {/* Section Header */}
          <h2 className="heading-2 mb-4">
            Featured in Leading Publications
          </h2>
          <p className="body-large text-[var(--text-secondary)] mb-12 max-w-3xl mx-auto">
            Joseph's work on the hidden protection gap in Indian families has been featured across major digital publications.
          </p>
          
          {/* PR Image */}
          <div className="mb-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_b2ceecb0-da08-477c-bdbc-45b3f8bca466/artifacts/p00megx8_PR%20Image%202.png"
              alt="Featured in Dailyhunt, The Business Stories, Hindustan Wires, The Entrepreneur Stories"
              className="w-full h-auto max-w-4xl mx-auto"
              loading="lazy"
            />
          </div>
          
          {/* Publication Names (for accessibility) */}
          <div className="text-sm text-[var(--text-light)] space-x-4">
            <span>Dailyhunt</span>
            <span>•</span>
            <span>The Business Stories</span>
            <span>•</span>
            <span>Hindustan Wires</span>
            <span>•</span>
            <span>The Entrepreneur Stories</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaAuthoritySection;
